import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/task/allocationsList/styles.scss';export default {
  "allocationsList": "_allocationsList_1446p_1",
  "allocation": "_allocation_1446p_1",
  "picture": "_picture_1446p_17",
  "summary": "_summary_1446p_23",
  "menu": "_menu_1446p_32",
  "addAllocationIcon": "_addAllocationIcon_1446p_36",
  "resourcesList": "_resourcesList_1446p_42"
};